"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_TestScript_Metadata = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_TestScript_Link_1 = require("./RTTI_TestScript_Link");
var RTTI_TestScript_Capability_1 = require("./RTTI_TestScript_Capability");
exports.RTTI_TestScript_Metadata = t.recursion('ITestScript_Metadata', function () {
    return t.intersection([
        t.type({
            capability: t.array(RTTI_TestScript_Capability_1.RTTI_TestScript_Capability)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            link: t.array(RTTI_TestScript_Link_1.RTTI_TestScript_Link)
        })
    ]);
});
//# sourceMappingURL=RTTI_TestScript_Metadata.js.map